<script>
import { mapState, mapMutations } from 'vuex';
import { Dialog } from 'mand-mobile';
import { transNumber } from '@utils/trans';

export default {
  name: 'VideoMessagePopup',
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: () => 'home'
    },
    isGroup: {
      type: Number,
      default: () => 0
    },
    show: {
      type: Boolean,
      default: () => false
    },
    count: {
      type: Number,
      default: () => 0
    }
  },
  data () {
    return {
      isShow: false
    };
  },
  computed: {
    ...mapState('publicStore', ['showHomeTips', 'publicConfig']),
    ...mapState('user', ['userInfo', 'walletInfo', 'token']),
    inviteData () {
      if (this.publicConfig.invite_key) {
        return this.publicConfig.invite_key;
      }
      return {
        invite_day: 0,
        invite_recharge_rebates: 0
      };
    },
    limit () {
      //  1. 判断当前观看视频的用户是否是发布视频的作者： 为是：放开限制，否：根据视频的限制来判断
      //  2. 专属视频：用户加入了粉丝团，免费观看
      const userUid = transNumber(this.userInfo.uid);
      const userVip = transNumber(this.userInfo.is_vip);
      const videoCount = transNumber(this.userInfo.video_count);
      const { balance } = this.walletInfo;
      if (userUid === this.item.id) {
        return [];
      }
      //  粉丝团判断
      if (this.type === 'authentication' || this.item.is_public === 3) {
        // console.log('粉丝团');
        if (this.isGroup !== 1) {
          if (this.item.is_money === 1 && transNumber(balance) < transNumber(this.item.money)) {
            return ['group', 'money'];
          }
          return ['group'];
        }
        return [];
      } else {
        //  金币充值
        if (this.item.is_money === 1 && this.item.is_vip !== 1) {
          //  金币充值
          // console.log('金币充值');
          // if (videoCount > 0) {
          //   return [];
          // }
          const isTrue = transNumber(balance) < transNumber(this.item.money);
          return videoCount === 0 || isTrue ? ['money'] : [];
        } else if (this.item.is_vip === 1 && this.item.is_money !== 1) {
          //  vip
          // console.log('vip');
          return userVip !== 1 ? ['vip'] : [];
        } else {
          return [];
        }
      }
    }
  },
  watch: {
    show (val) {
      if (this.$route.path === '/home') {
        if (val && this.limit.length > 0) {
          this.isShow = true;
        }
      } else {
        this.onClose();
      }
    }
  },
  methods: {
    ...mapMutations('publicStore', ['setShowHomeTips']),
    onRouter (route) {
      this.onClose();
      this.$router.push(route);
    },
    onClose () {
      this.setShowHomeTips(false);
      this.isShow = false;
    }
  }
};
</script>

<template>
  <md-dialog
      v-model="isShow"
      title=""
      ref="dialog"
      :closable="false"
      mask-closable
      @hide="onClose"
      class="video-message-popup"
  >
    <template #header>
      <div class="header-left header">
        <img src="./assets/icon1.png" alt="" />
      </div>
      <div class="header-right header">
        <img src="./assets/icon2.png" alt="" />
      </div>
    </template>
    <div class="h-40"></div>
    <div class="title">观看提示</div>
    <ul class="content">
      <li v-if="limit.includes('group')">
        <p>加入粉丝团即可观看完整视频</p>
      </li>
      <li v-if="limit.includes('money')">
        <p>仅需{{ item.money }}金币即可解锁完整版，点击确认付费后自动播放完整版视频</p>
      </li>
      <template v-if="limit.includes('vip')">
        <li>
          <span></span>
          <p>邀请好友立刻免费观看{{ inviteData.invite_day }}天</p>
        </li>
        <li>
          <span></span>
          <p>
            邀请好友购买VIP，您还可获得{{ inviteData.invite_recharge_rebates }}%返利！
          </p>
        </li>
        <li>
          <span></span>
          <p>充值会员后即可解锁全部VIP视频，确认后跳转到会员卡充值页面</p>
        </li>
      </template>
    </ul>
    <div class="actions">
      <div v-if="limit.includes('group')" class="buy-vip-btn action-btn" @click="onRouter(`/userDetail?uid=${item.uid}`)">
        加入粉丝团
      </div>
      <div v-if="limit.includes('money')" class="buy-vip-btn action-btn" @click="onRouter('/myWallet')">
        金币充值
      </div>
      <template v-if="limit.includes('vip')">
        <div class="invite-btn action-btn" @click="onRouter('/invite')">
          邀请无限看
        </div>
        <div class="buy-vip-btn action-btn" @click="onRouter('/memberRecharge')">
          开通VIP
        </div>
      </template>
    </div>
  </md-dialog>
</template>

<style scoped lang="scss">
.video-message-popup {
  /deep/ .md-dialog-content {
    background: #252436;
    .md-dialog-actions:after {
      display: none;
    }
  }
}
.header {
  position: absolute;
  &.header-left {
    left: 0;
    top: -54px;
    img {
      width: 122px;
    }
  }
  &.header-right {
    right: 0;
    top: -30px;
    img {
      width: 95px;
    }
  }
}
.h-40 {
  height: 15px;
}
.title {
  font-family: YouSheBiaoTiHei;
  font-size: 36px;
  font-weight: 400;
  letter-spacing: -0.8px;
  text-align: center;
  color: #FFD75F;
}
.content {
  margin: 20px 0 30px 0;
  li {
    display: flex;
    align-items: baseline;
    margin-bottom: 10px;
    span {
      width: 10px;
      height: 10px;
      background: linear-gradient(180deg, #F92D29 0%, #32B8AF 100%);
      border-radius: 50%;
      margin-right: 10px;
    }
    p {
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 23px;
      color: #fff;
      flex: 1;
    }
    &:last-child p {
      color: #F92D29;
    }
  }
}
.actions {
  display: flex;
  justify-content: center;
  .action-btn {
    border-radius: 6px;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding: 9px 6px;
    width: 118px;
    &:first-child {
      margin-right: 10px;
    }
    &.invite-btn {
      background: #252436;
      border: 1px solid #32B8AF;
      margin-right: 14px;
      color: #32B8AF;
    }
    &.buy-vip-btn {
      background: #32B8AF;
      color: #FFFFFF;
    }
  }
}
</style>
<style lang="scss">
.md-popup-box {
  overflow: initial;
}
</style>
